import React from 'react';
import './StatusBadge.css';

/**
 * Small uppercase pill used to flag the current site status
 * (e.g. "Fuera de servicio temporalmente").
 */
function StatusBadge({ label, dotColor = '#f5b72a' }) {
  return (
    <span className="StatusBadge">
      <span
        className="StatusBadge-dot"
        style={{ backgroundColor: dotColor }}
        aria-hidden="true"
      />
      {label}
    </span>
  );
}

export default StatusBadge;
